import React from 'react';
import './Disclaimer.css';

function Disclaimer() {
  return (
    <div className="disclaimer-page">
      <div className="container">
        <div className="disclaimer-content">
          <h1>Disclaimer</h1>
          
          <div className="disclaimer-section">
            <h2>Important Notice</h2>
            <p>
              Dear Job aspirants,
            </p>
            <p>
              JobsOpportunity is not a job placement agency or job placement consultant. 
              We neither do placement on company's behalf nor are we involved in any stage 
              of recruitment process. Our endeavor is to create a space where aspirants 
              Job Seekers can find information that is most relevant to and well aligned 
              to their career objectives.
            </p>
          </div>

          <div className="disclaimer-section">
            <h2>Information Sharing</h2>
            <p>
              Shared or Posted Information is for informational purposes only. We only 
              post the available and relevant jobs from the internet or social media. 
              The given Information has been taken from the official website of the 
              Companies / Organization. We are not involved directly or indirectly in 
              the recruitment process at any stage.
            </p>
          </div>

          <div className="disclaimer-section">
            <h2>Intellectual Property Rights</h2>
            <p>
              All the related Company logos and trademarks shared on JobsOpportunity 
              are the Intellectual / virtual property of their respective owner / Companies.
            </p>
          </div>

          <div className="disclaimer-section">
            <h2>Additional Information</h2>
            <ul>
              <li>We do not charge any fees for the information provided.</li>
              <li>We are not responsible for any changes or cancellations in job postings by companies.</li>
              <li>Users are advised to verify information independently before taking any action.</li>
              <li>We recommend applying for jobs through official company websites when possible.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Disclaimer; 